import styled from 'styled-components'
import {
  LEGACY_BREAKPOINT_QUERIES,
  createResponsiveBreakpointQuery
} from 'styles/breakpoints'

const tabletQuery = createResponsiveBreakpointQuery('tabletUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.tabletUp
})

const largeDesktopQuery = createResponsiveBreakpointQuery('largeDesktopUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.largeDesktopUp
})

export const ReleasesGrid = styled.div`
  display: grid;
  gap: 8px;
  /* Keep empty columns so a short result set retains the normal card spacing. */
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));

  @media ${tabletQuery} {
    gap: 16px;
    grid-template-columns: repeat(auto-fill, minmax(173px, 1fr));
  }

  @media ${largeDesktopQuery} {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
`
